import { Stack } from '@mui/material';
import { portalPaths, UrlSegments } from '@provision/portal-routes';
import { SyntheticEvent, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { NamedLayoutBlock } from 'src/components';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import { useNavigateRoute } from 'src/utils/routing';
import { IntegrationsTab, IntegrationsTabsRow } from './styled';

type TabValue = 'integrations' | 'developer';

export const IntegrationsView = () => {
  const { navigate } = useNavigateRoute();
  const { pathname } = useLocation();
  const { checkValidity, loading: loadingGroupRules } = useGroupRules();

  const allowDeveloperTab =
    !loadingGroupRules &&
    checkValidity([UserGroupRules.AccessToProvisionPublicApi], { matchType: 'all' });

  const activeTab: TabValue = useMemo(() => {
    const isDeveloperPath = pathname.endsWith(
      `/${UrlSegments.settings.integrationsDeveloper}`,
    );
    return isDeveloperPath && allowDeveloperTab ? 'developer' : 'integrations';
  }, [pathname, allowDeveloperTab]);

  const handleTabChange = (_event: SyntheticEvent, value: TabValue) => {
    if (value === 'developer') {
      navigate(portalPaths.settings.integrationsDeveloper());
    } else {
      navigate(portalPaths.settings.integrations());
    }
  };

  return (
    <NamedLayoutBlock
      title="Integrations"
      sx={{
        flex: 1,
        display: { sm: 'flex' },
      }}
    >
      <Stack sx={{ overflow: 'hidden', height: '100vh' }}>
        <IntegrationsTabsRow value={activeTab} onChange={handleTabChange}>
          <IntegrationsTab label="Integrations" value="integrations" />
          {allowDeveloperTab ? <IntegrationsTab label="Developer" value="developer" /> : null}
        </IntegrationsTabsRow>
        <Stack sx={{ flex: 1, minHeight: 0 }}>
          <Outlet />
        </Stack>
      </Stack>
    </NamedLayoutBlock>
  );
};
